export default __webpack_public_path__ + "assets/2e3615a5ca1995426d253461d2b580bf.ttf";